<template>
  <div class="">
    <!--Stats cards-->
    <!-- <button @click="getAccessStatistics(1)">holaa</button> -->
    <h4 class="card-title mt-2">Membresias</h4>
    <div v-if="membershipsIsLoading">
      <Loading class="mx-auto"></Loading>
    </div>
    <template v-else>
      <div class="col-md-12 card py-4 d-md-none">
        <div class="card-head">
          <h6>Conteo socios por estado plan</h6>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">ESTADO</th>
              <th scope="col" class="text-center">Total</th>
              <th scope="col" class="text-center">
                <i class="fa fa-search"></i>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <th scope="row">
                <a> {{ statsCards.VIGENTE.title }}</a>
              </th>
              <td class="text-center">
                <a>{{ statsCards.VIGENTE.value }}</a>
              </td>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Descargar Excel"
                  @click.native="
                    goToCustomers(
                      statsCards.VIGENTE.cat,
                      statsCards.VIGENTE.title
                    )
                  "
                >
                  <i class="fa fa-search"></i>
                </p-button>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <a> {{ statsCards.PAGADO.title }}</a>
              </th>
              <td class="text-center">
                <a>{{ statsCards.PAGADO.value }}</a>
              </td>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Descargar Excel"
                  @click.native="
                    goToCustomers(
                      statsCards.PAGADO.cat,
                      statsCards.PAGADO.title
                    )
                  "
                >
                  <i class="fa fa-search"></i>
                </p-button>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <a> {{ statsCards.CONGELADO.title }}</a>
              </th>
              <td class="text-center">
                <a>{{ statsCards.CONGELADO.value }}</a>
              </td>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Descargar Excel"
                  @click.native="
                    goToCustomers(
                      statsCards.CONGELADO.cat,
                      statsCards.CONGELADO.title
                    )
                  "
                >
                  <i class="fa fa-search"></i>
                </p-button>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <a> {{ statsCards.PENDIENTE.title }}</a>
              </th>
              <td class="text-center">
                <a>{{ statsCards.PENDIENTE.value }}</a>
              </td>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Descargar Excel"
                  @click.native="
                    goToCustomers(
                      statsCards.PENDIENTE.cat,
                      statsCards.PENDIENTE.title
                    )
                  "
                >
                  <i class="fa fa-search"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="card-head">
          <h6>RESUMEN</h6>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col" class="">SOCIOS ACTIVOS TOTALES</th>
              <th scope="col" class="text-center">
                <i class="fa fa-search"></i>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <th scope="row" class="text-center">
                <a> {{ statsCards.ACTIVOS.value }}</a>
              </th>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Ver Membresias"
                  @click.native="goToCustomers('', '')"
                >
                  <i class="fa fa-search"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="row d-none d-md-flex flex-nowrap position-relative"
        ref="myDiv"
        id="tuDiv"
        style="overflow: hidden; scroll-behavior: smooth"
      >
        <!-- <div v-if="isOverflowed" class="position-absolute container-fluid d-flex w-100 p-4" style="z-index: 1000;">
        <i v-if="!horizontalScrollToggle" class="fa fa-chevron-left fa-3x text-center m-4" style="color: #2c2c2c" @click="fscrollToLeft()"></i>
        <button class="btn" @click="fscrollToLeft()">holaaaaa</button>
        <button class="btn" @click="fscrollToRight()">chaup</button>
        <i v-else class="fa fa-chevron-right fa-3x text-center ml-auto m-4" @click="fscrollToRight()"></i>
      </div> -->

        <div class="col-9 col-md-auto">
          <el-tooltip
            content="Total membresias [VIGENTES] + [PAGADAS] + [CONGELADAS]"
            :open-delay="300"
            placement="top"
          >
            <stats-card
              :type="statsCards.ACTIVOS.type"
              :icon="statsCards.ACTIVOS.icon"
              :small-title="statsCards.ACTIVOS.title"
              :title="statsCards.ACTIVOS.value"
              @click.native="goToCustomers('', '')"
              style="cursor: pointer"
              class="mb-0"
            >
              <div class="stats" slot="footer">
                <i :class="statsCards.ACTIVOS.footerIcon"></i>
                Updated now
              </div>
            </stats-card>
          </el-tooltip>
        </div>
        <div class="col-9 col-md-auto">
          <stats-card
            :type="statsCards.VIGENTE.type"
            :icon="statsCards.VIGENTE.icon"
            :small-title="statsCards.VIGENTE.title"
            :title="statsCards.VIGENTE.value"
            @click.native="
              goToCustomers(statsCards.VIGENTE.cat, statsCards.VIGENTE.title)
            "
            style="cursor: pointer"
            class="mb-0"
          >
            <div class="stats" slot="footer">
              <i :class="statsCards.VIGENTE.footerIcon"></i>
              {{ statsCards.VIGENTE.footerText }}
            </div>
          </stats-card>
        </div>
        <div class="col-9 col-md-auto">
          <stats-card
            :type="statsCards.PAGADO.type"
            :icon="statsCards.PAGADO.icon"
            :small-title="statsCards.PAGADO.title"
            :title="statsCards.PAGADO.value"
            @click.native="
              goToCustomers(statsCards.PAGADO.cat, statsCards.PAGADO.title)
            "
            style="cursor: pointer"
            class="mb-0"
          >
            <div class="stats" slot="footer">
              <i :class="statsCards.PAGADO.footerIcon"></i>
              {{ statsCards.PAGADO.footerText }}
            </div>
          </stats-card>
        </div>
        <div class="col-9 col-md-auto">
          <stats-card
            :type="statsCards.CONGELADO.type"
            :icon="statsCards.CONGELADO.icon"
            :small-title="statsCards.CONGELADO.title"
            :title="statsCards.CONGELADO.value"
            @click.native="
              goToCustomers(
                statsCards.CONGELADO.cat,
                statsCards.CONGELADO.title
              )
            "
            style="cursor: pointer"
            class="mb-0"
          >
            <div class="stats" slot="footer">
              <i :class="statsCards.CONGELADO.footerIcon"></i>
              {{ statsCards.CONGELADO.footerText }}
            </div>
          </stats-card>
        </div>
        <div class="col-9 col-md-auto">
          <stats-card
            :type="statsCards.PENDIENTE.type"
            :icon="statsCards.PENDIENTE.icon"
            :small-title="statsCards.PENDIENTE.title"
            :title="statsCards.PENDIENTE.value"
            @click.native="
              goToCustomers(
                statsCards.PENDIENTE.cat,
                statsCards.PENDIENTE.title
              )
            "
            style="cursor: pointer"
            class="mb-0"
          >
            <div class="stats" slot="footer">
              <i :class="statsCards.PENDIENTE.footerIcon"></i>
              {{ statsCards.PENDIENTE.footerText }}
            </div>
          </stats-card>
        </div>
      </div>
      <div
        v-if="isOverflowed"
        class="d-flex position-absolute"
        style="width: 95%"
      >
        <i
          v-if="!horizontalScrollToggle"
          class="fa fa-chevron-circle-left fa-3x"
          style="
            color: #2c2c2cc5;
            z-index: 1000;
            cursor: pointer;
            margin-top: -100px;
            text-shadow: 2px 2px 3px #2c2c2c50;
          "
          @click="fscrollToLeft()"
        ></i>
        <!-- <button class="btn" @click="fscrollToLeft()">holaaaaa</button>
      <button class="btn" @click="fscrollToRight()">chaup</button> -->
        <i
          v-if="horizontalScrollToggle"
          class="fa fa-chevron-circle-right fa-3x ml-auto mr-0"
          @click="fscrollToRight()"
          style="
            color: #2c2c2cc5;
            z-index: 1000;
            cursor: pointer;
            margin-top: -100px;
            text-shadow: 2px 2px 3px #2c2c2c50;
          "
        ></i>
      </div>
    </template>
    <h5 class="mt-4 mb-0">Tramo de cobro por sucursal</h5>
    <template v-if="!membershipsIsLoading">
      <div class="d-flex flex-md-row flex-wrap justify-content-start mt-2">
        <div
          v-for="branch in branchesBilling"
          class="text-center px-2 card text-monospace mr-2"
          :key="branch._id"
          :class="{
            'bg-warning': branch.billing === 1,
            'bg-success': branch.billing === 2,
            'bg-primary': branch.billing === 3,
            'bg-info': branch.billing === 4,
            'bg-secondary text-light': branch.billing === 5,
            'bg-dark text-light': branch.billing === 6,
          }"
        >
          <p class="card-header my-0 pt-0 pb-0">{{ branch._id }}</p>
          <p class="card-body my-0 py-0">
            Activos: {{ branch.count }} - Tramo: {{ branch.billing }}
          </p>
        </div>
      </div>
    </template>

    <hr class="mt-3" />
    <!-- version pequeña de tarjetas -->
    <!-- <div class="d-flex flex-row justify-content-around">
      <div class="card">
        <div class="d-flex flex px-2">
          <div class="icon-big text-center text-warning d-flex">
            <i
            class="nc-icon nc-simple-add m-auto"
            style="color: #fbc658; font-size: 40px"
            ></i>
          </div>
          <div class="card-header text-right">
            <h6 class="text-muted">{{ statsCards.ACTIVOS.title }}</h6>
            <h5>{{ statsCards.ACTIVOS.value }}</h5>
          </div>
        </div>
        <hr class="my-0 w-75 mx-auto">
        <div class="card-body text-muted">
          {{statsCards.ACTIVOS.sub}}
        </div>
      </div>
      <div class="card">
        <div class="d-flex flex px-2">
          <div class="icon-big text-center text-success d-flex">
            <i
            class="nc-icon nc-user-run m-auto"
            style="font-size: 40px"
            ></i>
          </div>
          <div class="card-header text-right">
            <h6 class="text-muted">{{ statsCards.VIGENTE.title }}</h6>
            <h5>{{ statsCards.VIGENTE.value }}</h5>
          </div>
        </div>
        <hr class="my-0 w-75 mx-auto">
        <div class="card-body text-muted">
          {{statsCards.ACTIVOS.sub}}
        </div>
      </div>
      <div class="card">
        <div class="d-flex flex px-2">
          <div class="icon-big text-center text-primary d-flex">
            <i
            class="nc-icon nc-user-run m-auto"
            style="font-size: 40px"
            ></i>
          </div>
          <div class="card-header text-right">
            <h6 class="text-muted">{{ statsCards.PAGADO.title }}</h6>
            <h5>{{ statsCards.PAGADO.value }}</h5>
          </div>
        </div>
        <hr class="my-0 w-75 mx-auto">
        <div class="card-body text-muted">
          {{statsCards.ACTIVOS.sub}}
        </div>
      </div>
      <div class="card">
        <div class="d-flex flex px-2">
          <div class="icon-big text-center text-info d-flex">
            <i
            class="nc-icon nc-user-run m-auto"
            style="font-size: 40px"
            ></i>
          </div>
          <div class="card-header text-right">
            <h6 class="text-muted">{{ statsCards.CONGELADO.title }}</h6>
            <h5>{{ statsCards.CONGELADO.value }}</h5>
          </div>
        </div>
        <hr class="my-0 w-75 mx-auto">
        <div class="card-body text-muted">
          {{statsCards.ACTIVOS.sub}}
        </div>
      </div>
      <div class="card">
        <div class="d-flex flex px-2">
          <div class="icon-big text-center text-danger d-flex">
            <i
            class="nc-icon nc-user-run m-auto"
            style="font-size: 40px"
            ></i>
          </div>
          <div class="card-header text-right">
            <h6 class="text-muted">{{ statsCards.PENDIENTE.title }}</h6>
            <h5>{{ statsCards.PENDIENTE.value }}</h5>
          </div>
        </div>
        <hr class="my-0 w-75 mx-auto">
        <div class="card-body text-muted">
          {{statsCards.ACTIVOS.sub}}
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-6">
        <h4 class="card-title mt-2">Accesos</h4>
        <el-slider
          class="slider-success px-2"
          v-model="sliders.simple"
          :show-tooltip="false"
          :min="0"
          :max="4"
          :marks="marks"
        >
        </el-slider>
        <div
          v-if="!AccessStatisticsIsLoading"
          class="mt-5 d-flex row container-fluid mb-0"
        >
          <ul col-6>
            <p class="mb-1">Promedio Diario</p>
            <p class="mb-0">Horario mas concurrido</p>
          </ul>
          <ul col-6>
            <p class="mb-1">{{ this.activeUsersChart.datasets[0].average }}</p>
            <p class="mb-0">
              {{ this.activeUsersChart.datasets[0].peak._id }}:Hrs
            </p>
          </ul>
        </div>
        <h5 v-if="!AccessStatisticsIsLoading" class="d-none d-md-flex">
          Detalle Sucursales
        </h5>
        <div
          v-if="!AccessStatisticsIsLoading"
          class="card col-12 d-none d-md-flex"
        >
          <div class="card-header">
            <ul class="nav nav-pills card-header-pills">
              <li
                class="nav-item"
                :class="{ active: index === AccessStatisticsActiveLink }"
                v-for="(branch, index) in branches"
                :key="index"
              >
                <a
                  class="nav-link"
                  @click="updateBranchesCard(index)"
                  style="border: none; width: 10px"
                  >{{ index + 1 }}</a
                >
              </li>
            </ul>
          </div>
          <div class="card-body">
            <h5 class="card-title">
              {{ this.branchesCardShow.Title }}
            </h5>
            <div class="d-flex row container-fluid justify-content-center">
              <ul class="col-6">
                <p class="text-right mb-0">Total</p>
                <p class="text-right">Promedio Diario</p>
              </ul>
              <ul class="col-6">
                <p class="text-left mb-0">
                  {{ this.branchesCardShow.Total }}
                </p>
                <p class="text-left">{{ this.branchesCardShow.average }}</p>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="AccessStatisticsIsLoading">
          <Loading class="mx-auto"></Loading>
        </div>
      </div>

      <div class="col-sm-6">
        <card>
          <template slot="header">
            <h4 class="card-title d-none d-md-flex">
              Horarios mas concurridos
            </h4>
            <h6 class="card-title d-md-none">Horarios mas concurridos</h6>
            <div class="d-flex container-fluid row justify-content-between">
              <p class="display-6">
                Utlimos {{ this.activeUsersChart.datasets[0].range }} días
              </p>
              <span
                >Total:
                <badge slot="title-label" type="success">{{
                  this.activeUsersChart.datasets[0].total
                }}</badge></span
              >
            </div>
          </template>
          <div v-if="AccessStatisticsIsLoading" class="flex mx-auto">
            <Loading></Loading>
          </div>
          <bar-chart
            v-else
            :labels="activeUsersChart.labels"
            :height="250"
            :datasets="activeUsersChart.datasets"
            v-bind="activeUsersChart.datasets"
          >
          </bar-chart>
        </card>

        <h5 v-if="!AccessStatisticsIsLoading" class="d-md-none">
          Detalle Sucursales
        </h5>
        <div v-if="!AccessStatisticsIsLoading" class="card col-12 d-md-none">
          <div class="card-header">
            <ul class="nav nav-pills card-header-pills">
              <li
                class="nav-item"
                :class="{ active: index === AccessStatisticsActiveLink }"
                v-for="(branch, index) in branches"
                :key="index"
              >
                <a
                  class="nav-link"
                  @click="updateBranchesCard(index)"
                  style="border: none; width: 10px"
                  >{{ index + 1 }}</a
                >
              </li>
            </ul>
          </div>
          <div class="card-body">
            <h6 class="card-title">
              {{ this.branchesCardShow.Title }}
            </h6>
            <div class="d-flex row container-fluid justify-content-center">
              <ul class="col-6">
                <p class="text-right mb-0">Total</p>
                <p class="text-right">Promedio Diario</p>
              </ul>
              <ul class="col-6">
                <p class="text-left mb-0">
                  {{ this.branchesCardShow.Total }}
                </p>
                <p class="text-left">{{ this.branchesCardShow.average }}</p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row my-2">
      <div class="col-md-4 px-2">
        <div class="d-flex flex-row justify-content-between px-0">
          <h4 class="mt-0 mr-4">Ventas</h4>
          <el-select
            class="select-default"
            v-model="SalesStatsBranchFilter"
            :placeholder="userBranches[0].nombreSucursal"
          >
            <el-option class="select-default" label="TODAS" :value="false">
            </el-option>
            <el-option
              class="select-default"
              v-for="item in userBranches"
              :key="item._id"
              :label="item.nombreSucursal"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </div>
        <el-slider
          class="slider-success px-4"
          v-model="sliders.sales"
          :show-tooltip="false"
          :min="0"
          :max="4"
          :marks="salesMarks"
        >
        </el-slider>
        <div class="container-fluid mt-4 pt-2 col-12">
          <h6 class="my-4 px-0">resumen</h6>
          <div class="row container-fluid d-flex justify-content-between">
            <p class="col-6 px-0 text-start">Ingresos totales</p>
            <p class="">:</p>
            <p class="col-5 px-0">
              $ {{ this.salesStats.totalIncome.toLocaleString("en-US") }}
            </p>
          </div>
          <div class="row container-fluid d-flex justify-content-between">
            <p class="col-6 px-0 text-start">Promedio diario</p>
            <p class="">:</p>
            <p class="col-5 px-0">
              $ {{ this.salesStats.dailyAverage.toLocaleString("en-US") }}
            </p>
          </div>
          <div
            v-if="!SalesStatsBranchFilter"
            class="row container-fluid d-flex justify-content-between"
          >
            <p class="col-6 px-0 text-start">Mejor sucursal</p>
            <p class="">:</p>
            <p class="col-5 px-0">{{ this.salesStats.bestBranch }}</p>
          </div>
          <div v-else class="row container-fluid">
            <p class="col-6 px-0 text-start mt-auto mb-0">Filtrar caja</p>
            <!-- <input
              type="number"
              class="form-control col-3 mx-2"
              min="0"
              max="14"
              placeholder="n°"
              v-model="branchBoxFilter"
            /> -->
            <el-select v-model="branchBoxFilter" size="small" class="col-6">
              <el-option
                v-for="(box, index) in boxes"
                :key="index"
                :value="box.value"
                :label="box.label"
              ></el-option>
            </el-select>
            <!-- <p-button size="sm my-0" type="info" outline icon round>
              <i class="fa fa-search text-info"></i>
            </p-button> -->
          </div>
        </div>
      </div>
      <div
        id="salesChart3"
        class="col-md-8 chart container-fluid ratio ratio-1x1 mb-2"
      ></div>
    </div>
    <div class="row my-2 d-flex sales-charts">
      <div
        id="salesChart2"
        class="col-md-6 chart container-fluid my-2 d-flex"
      ></div>
      <!-- <div class="col-md-6">
        <div id="salesChart3"></div>
      </div> -->
      <div id="chart" class="col-md-6 container-fluid my-2 d-flex"></div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 card">
        <div class="card-header d-flex container-fluid justify-content-between">
          <h4 class="my-auto">Registro cierres de caja</h4>
          <div class="d-flex flex-column">
            <label for="">Fecha de registro</label>
            <el-date-picker
              type="daterange"
              size="small"
              range-separator=":"
              start-placeholder="Desde"
              end-placeholder="Hasta"
              class="d-none d-md-inline-flex mx-auto"
              :unlink-panels="true"
              format="dd-MM-yyyy"
              value-format="dd-MM-yyyy"
              v-model="dateBoxFilter"
            />
          </div>
          <div class="d-flex flex-column col-2">
            <label for="">Cajas</label>
            <el-select class="select-default" size="small" v-model="boxFilter">
              <el-option value="" label="todas"></el-option>
              <el-option value="1" label="1"></el-option>
              <el-option value="2" label="2"></el-option>
              <el-option value="3" label="3"></el-option>
              <el-option value="4" label="4"></el-option>
              <el-option value="5" label="5"></el-option>
              <el-option value="6" label="6"></el-option>
              <el-option value="7" label="7"></el-option>
              <el-option value="8" label="8"></el-option>
              <el-option value="9" label="9"></el-option>
              <el-option value="10" label="10"></el-option>
              <el-option value="11" label="11"></el-option>
              <el-option value="12" label="12"></el-option>
              <el-option value="13" label="13"></el-option>
              <el-option value="14" label="14"></el-option>
              <template v-if="acountType === 'SOPORTE'">
                <el-option value="15" label="15"></el-option>
              </template>
            </el-select>
          </div>
          <div class="d-flex flex-column col-auto">
            <label for="">Sucursales</label>
            <el-select
              class="select-default"
              v-model="CashClosingBranchFilter"
              :placeholder="userBranches[0].nombreSucursal"
              size="small"
            >
              <el-option class="select-default" label="TODAS" :value="false">
              </el-option>
              <el-option
                class="select-default"
                v-for="item in userBranches"
                :key="item._id"
                :label="item.nombreSucursal"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="d-flex flex-column text-info">
            <label for="">Exportar</label>
            <el-tooltip
              content="Exportar resumenes"
              :open-delay="100"
              placement="top"
            >
              <p-button
                outline
                icon
                round
                type="info"
                class="mt-0 mx-auto"
                @click="handleExportCashClosings()"
                :disabled="!cashClosings.length"
              >
                <i class="fa fa-cloud-download fa-lg" aria-hidden="true"></i>
              </p-button>
            </el-tooltip>
          </div>
        </div>
        <hr class="" />
        <div class="card-body row d-none d-lg-flex">
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="cashClosings"
              border
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column
                :min-width="80"
                fixed="right"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <p-button
                    type="info"
                    size="sm"
                    icon
                    title="Ver Detalle"
                    @click="showCCModal(props.row.id)"
                    data-toggle="modal"
                    data-target="#staticBackdrop"
                  >
                    <i class="fa fa-search"></i>
                  </p-button>
                  <p-button
                    type="success"
                    size="sm"
                    icon
                    title="Descargar Excel"
                    @click="
                      downloadCC(
                        props.row.id,
                        props.row.responsable,
                        props.row.caja,
                        props.row.fecha
                      )
                    "
                  >
                    <i class="fa fa-arrow-down"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="CashClosingsIsLoading">
              <Loading></Loading>
            </div>
          </div>
          <!-- <div class="col-sm-6 mt-3">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="onPageChange"
            >
            </p-pagination>
          </div> -->
        </div>
        <!-- MOBILE CASHCLOSINGS -->

        <table class="table table-striped d-lg-none">
          <thead>
            <tr>
              <th scope="col">CAJA</th>
              <th scope="col">Sucursal</th>
              <th scope="col">Fecha</th>
              <th scope="col" class="text-center">
                <i class="fa fa-arrow-down"></i>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in cashClosings" :key="item.id">
              <th
                @click="showCCModalMobile(item.id)"
                scope="row"
                class="text-center"
              >
                <a> {{ item.caja.split(" ")[1] }}</a>
              </th>
              <td @click="showCCModalMobile(item.id)">
                <a>{{ item.sucursal }}</a>
              </td>
              <td @click="showCCModalMobile(item.id)" class="p-0">
                <a
                  ><small>{{ item.fecha }}</small></a
                >
              </td>
              <td class="text-center">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  title="Descargar Excel"
                  @click="
                    downloadCC(item.id, item.responsable, item.caja, item.fecha)
                  "
                >
                  <i class="fa fa-arrow-down"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="CashClosingsIsLoading"
          class="w-100 d-flex justify-content-center container-fluid"
        >
          <Loading class="d-md-none"></Loading>
        </div>
        <div
          class="col-sm-6 mt-3 container-fluid d-flex justify-content-center"
        >
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total.sync="pagination.total"
            @input="onPageChange"
          >
          </p-pagination>
        </div>
      </div>
    </div>
    <!-- CASH CLOSINGS MODAL -->
    <div
      id="CCShowDetails"
      class="position-fixed fixed-top container-fluid flex p-4 d-none"
      style="z-index: 1030; height: 100vh; width: 100vw"
    >
      <div
        class="col-md-6 m-auto h-100 py-3 rounded"
        style="background-color: #f4f3ef"
      >
        <div class="flex row justify-content-between px-4">
          <h2 class="mb-4">Detalle Cierre de Caja</h2>
          <!-- <a @click="hideCCModal()"><h5>X</h5></a> -->
        </div>
        <div class="overflow-auto h-75 mt-4 py-2">
          <h4 class="mb-1">Datos Generales</h4>
          <hr class="mt-0" />
          <div class="flex row container-fluid">
            <div class="col-4">
              <ul class="list-group list-group-flush">
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Responsable
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Caja
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Fecha cierre
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Hora cierre
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Fecha apertura
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Hora apertura
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Sucursal
                </li>
              </ul>
            </div>
            <div class="col-md-8">
              <ul class="list-group list-group-flush h-100">
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.responsable || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.caja || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.fechaCierre || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.horaCierre || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.fechaApertura || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.horaApertura || "No Data" }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  {{ this.CCModalData.nombreSucursal || "No Data" }}
                </li>
              </ul>
            </div>
          </div>
          <h4 class="mb-1">Ventas Total Sistema</h4>
          <hr class="mt-0" />
          <div class="flex row container-fluid">
            <div class="col-md-4">
              <ul class="list-group list-group-flush">
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Efectivo
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  TDebito
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  TCredito
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Cheque
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Transferencia
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  CreditoLocal
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Total
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Monto inicial
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Total en caja
                </li>
              </ul>
            </div>
            <div class="col-md-7">
              <ul class="list-group list-group-flush">
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasEfectivo || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasTDebito || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasTCredito || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasCheque || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasTransferencia || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasCreditoLocal || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.ventasTotales || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.cajaInicial || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalSistema.totalEnCaja || 0 }}
                </li>
              </ul>
            </div>
          </div>
          <h4 class="mb-1">Ventas Total Ratificado</h4>
          <hr class="mt-0" />
          <div class="flex row container-fluid">
            <div class="col-md-4">
              <ul class="list-group list-group-flush h-100">
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Efectivo
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  TDebito
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  TCredito
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Cheque
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Transferencia
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  CreditoLocal
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Total
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Monto inicial
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Total en caja
                </li>
                <li
                  style="background-color: #f4f3ef"
                  class="list-group-item border-light"
                >
                  Diferencia
                </li>
              </ul>
            </div>
            <div class="col-md-7">
              <ul class="list-group list-group-flush h-100">
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.ventasEfectivo || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.ventasTDebito || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.ventasTCredito || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.ventasCheque || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $
                  {{
                    this.CCModalData.totalRatificado.ventasTransferencia || 0
                  }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $
                  {{ this.CCModalData.totalRatificado.ventasCreditoLocal || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.ventasTotales || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.cajaInicial || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.totalEnCaja || 0 }}
                </li>
                <li style="background-color: #f4f3ef" class="list-group-item">
                  $ {{ this.CCModalData.totalRatificado.totalDiferencia || 0 }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-end p-4">
          <button
            class="btn btn-danger align-self-baseline"
            @click="hideCCModal()"
          >
            cerrar
          </button>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.notice"
      footerClasses="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="modal-title">Detalle Cierre de Caja</h5>
      <template>
        <div class="">
          <div class="row my-1">
            <strong>1. Datos Generales</strong>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Responsable</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.responsable || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Caja</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.caja || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Fecha Cierre</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.fechaCierre || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Hora Cierre</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.horaCierre || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Fecha Apertura</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.fechaApertura || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Hora Apertura</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.horaApertura || "No Data" }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Sucursal</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              {{ this.CCModalData.nombreSucursal || "No Data" }}
            </div>
          </div>
        </div>
        <div class="">
          <div class="row my-1">
            <strong>2. Ventas Total Sistema</strong>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Efectivo</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasEfectivo || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">TDebito</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasTDebito || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">TCredito</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasTCredito || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Cheque</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasCheque || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Transferencia</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasTransferencia || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">CreditoLocal</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasCreditoLocal || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Total</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.ventasTotales || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Monto inicial</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.cajaInicial || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Total en caja</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalSistema.totalEnCaja || 0 }}
            </div>
          </div>
        </div>
        <div class="">
          <div class="row my-1">
            <strong>3. Ventas Total Ratificado</strong>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Efectivo</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasEfectivo || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">TDebito</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasTDebito || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">TCredito</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasTCredito || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Cheque</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasCheque || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Transferencia</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasTransferencia || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">CreditoLocal</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasCreditoLocal || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Total</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.ventasTotales || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Monto inicial</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.cajaInicial || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Total en caja</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.totalEnCaja || 0 }}
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-6 col-md-4">Diferencia</div>
            <div class="">:</div>
            <div class="col-5 col-md-7">
              $ {{ this.CCModalData.totalRatificado.totalDiferencia || 0 }}
            </div>
          </div>
        </div>
      </template>
      <div class="justify-content-center container-fluid d-flex mt-4">
        <p-button type="danger" round @click.native="modals.notice = false"
          >Cerrar</p-button
        >
      </div>
    </modal>
  </div>
</template>
<script>
import CircleChartCard from "src/components/UIComponents/Cards/CircleChartCard.vue";
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import Card from "src/components/UIComponents/Cards/Card";
import StatsCard from "src/components/UIComponents/Cards/StatsCard";
import BarChart from "src/components/UIComponents/Charts/BarChart";
import PPagination from "src/components/UIComponents/Pagination.vue";
import { Badge, Modal } from "src/components/UIComponents";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import TaskList from "./Widgets/TaskList";
import axios from "axios";
import moment from "moment";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import XLSXpopulate from "xlsx-populate";
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import Vue from "vue";
import { allowContextMenu } from "@fullcalendar/core";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
const WorldMap = () => ({
  component: import("../Maps/WorldMap.vue"),
  loading: Loading,
  delay: 200,
});
// const ChartSDK = new this.$ChartSDK({
//   baseURL: "https://charts.mongodb.com/charts-project-0-gnulx"
// })
export default {
  components: {
    StatsCard,
    ChartCard,
    Card,
    CircleChartCard,
    WorldMap,
    Badge,
    Loading,
    TaskList,
    PPagination,
    BarChart,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  computed: {},
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      acountType: "",
      modals: {
        classic: false,
        notice: false,
        mini: false,
      },
      membershipsIsLoading: true,
      pagination: {
        perPage: 5,
        currentPage: 1,
        total: 0,
      },
      tableColumns: [
        {
          prop: "sucursal",
          label: "Sucursal",
          minWidth: 250,
        },
        {
          prop: "responsable",
          label: "Responsable",
          minWidth: 200,
        },
        {
          prop: "caja",
          label: "Caja",
          minWidth: 100,
        },
        {
          prop: "fecha",
          label: "Fecha",
          minWidth: 100,
        },
      ],
      cashClosings: [],
      sliders: {
        simple: 0,
        sales: 0,
      },
      statsCards: {
        ACTIVOS: {
          type: "warning",
          icon: `nc-icon nc-simple-add`,
          title: `ACTIVOS`,
          value: "0",
          cat: "",
          footerText: "Updated now",
        },
        VIGENTE: {
          type: "success",
          icon: `nc-icon nc-user-run`,
          title: `VIGENTE`,
          value: "0",
          cat: "",
          footerText: "Updated now",
        },
        PAGADO: {
          type: "primary",
          icon: `nc-icon nc-user-run`,
          title: `PAGADO`,
          value: "0",
          cat: "",
          footerText: "Updated now",
        },
        CONGELADO: {
          type: "info",
          icon: `nc-icon nc-user-run`,
          title: `CONGELADO`,
          value: "0",
          cat: "",
          footerText: "Updated now",
        },
        PENDIENTE: {
          type: "danger",
          icon: `nc-icon nc-user-run`,
          title: `PENDIENTE`,
          value: "0",
          cat: "",
          footerText: "Updated now",
        },
      },
      branchesBilling: [],
      activeCatlog: [],
      activeUsersChart: {
        labels: [
          "00Hrs",
          "01Hrs",
          "02Hrs",
          "03Hrs",
          "04Hrs",
          "05Hrs",
          "06Hrs",
          "07Hrs",
          "08Hrs",
          "09Hrs",
          "10Hrs",
          "11Hrs",
          "12Hrs",
          "13Hrs",
          "14Hrs",
          "15Hrs",
          "16Hrs",
          "17Hrs",
          "18Hrs",
          "19Hrs",
          "20Hrs",
          "21Hrs",
          "22Hrs",
          "23Hrs",
        ],
        datasets: [
          {
            total: 0,
            range: 0,
            label: "Data",
            borderColor: "#fcc468",
            fill: true,
            backgroundColor: "#fcc468",
            hoverBorderColor: "#fcc468",
            borderWidth: 5,
            average: 0,
            peak: "",
            data: [],
          },
        ],
      },
      marks: {
        0: "hoy",
        1: "7 días",
        2: "1 mes",
        3: "6 meses",
        4: "1 año",
      },
      salesMarks: {
        0: "7 días",
        1: "1 mes",
        2: "6 meses",
        3: "1 año",
        4: "Full",
      },
      branches: [],
      branchesCardShow: {
        Title: "",
        Total: "",
        average: "",
      },
      salesStats: {
        totalIncome: 0,
        dailyAverage: 0,
        bestBranch: "",
      },
      salesCharts: {
        bar: {},
        pie: {},
        line: {},
      },
      boxes: [
        { label: "TODAS", value: false },
        { label: "CAJA 1", value: "CAJA 1" },
        { label: "CAJA 2", value: "CAJA 2" },
        { label: "CAJA 3", value: "CAJA 3" },
        { label: "CAJA 4", value: "CAJA 4" },
        { label: "CAJA 5", value: "CAJA 5" },
        { label: "CAJA 6", value: "CAJA 6" },
        { label: "CAJA 7", value: "CAJA 7" },
        { label: "CAJA 8", value: "CAJA 8" },
        { label: "CAJA 9", value: "CAJA 9" },
        { label: "CAJA 10", value: "CAJA 10" },
        { label: "CAJA 11", value: "CAJA 11" },
        { label: "CAJA 12", value: "CAJA 12" },
        { label: "CAJA 13", value: "CAJA 13" },
        { label: "CAJA 14", value: "CAJA 14" },
      ],
      salesSliderCV: 0,
      branchBoxFilter: false,
      SalesStatsBranchFilter: false,
      boxFilter: "",
      dateBoxFilter: null,
      AccessStatisticsIsLoading: false,
      CashClosingsIsLoading: false,
      CashClosingBranchFilter: false,
      AccessStatisticsActiveLink: 0,
      CCModalData: {
        caja: "",
        fechaApertura: "",
        fechaCierre: "",
        fechaRegistro: "",
        horaApertura: "",
        horaCierre: "",
        nombreSucursal: "",
        responsable: "",
        totalRatificado: {
          cajaInicial: 0,
          indicadorDiferencia: "",
          totalDiferencia: 0,
          totalEnCaja: 0,
          ventasCheque: 0,
          ventasCreditoLocal: 0,
          ventasEfectivo: 0,
          ventasTCredito: 0,
          ventasTDebito: 0,
          ventasTotales: 0,
          ventasTransferencia: 0,
        },
        totalSistema: {
          cajaInicial: 0,
          totalEnCaja: 0,
          ventasCheque: 0,
          ventasCreditoLocal: 0,
          ventasEfectivo: 0,
          ventasTCredito: 0,
          ventasTDebito: 0,
          ventasTotales: 0,
          ventasTransferencia: 0,
        },
      },
      isOverflowed: true,
      horizontalScrollToggle: true,
      userBranches: [],
      exportData: [],
    };
  },
  watch: {
    dateBoxFilter: function (newValue) {
      // console.log("new date box filter");
      // console.log(newValue);
      // console.log(typeof newValue);
      this.filterCCByBranch();
    },
    boxFilter: function (newValue) {
      // console.log("new date box filter");
      // console.log(newValue);
      this.filterCCByBranch();
    },
    "sliders.simple": function (newValue) {
      let days;
      let since;
      let today = moment();
      switch (newValue) {
        case 0:
          days = 1;
          break;
        case 1:
          days = 7;
          break;
        case 2:
          since = moment().subtract(1, "months");
          days = today.diff(since, "days");
          break;
        case 3:
          since = moment().subtract(6, "months");
          days = today.diff(since, "days");
          break;
        case 4:
          since = moment().subtract(1, "years");
          days = today.diff(since, "days");
          break;
      }
      this.updateGetAccessStatistics(days);
    },
    "sliders.sales": function (newValue) {
      let days;
      let since;
      let today = moment();
      this.salesSliderCV = newValue;
      switch (newValue) {
        case 0:
          days = 7;
          break;
        case 1:
          since = moment().subtract(1, "months");
          days = today.diff(since, "days");
          break;
        case 2:
          since = moment().subtract(6, "months");
          days = today.diff(since, "days");
          break;
        case 3:
          since = moment().subtract(1, "years");
          days = today.diff(since, "days");
          break;
        case 4:
          days = false;
          break;
      }

      this.updateSalesStatistics(days);
      this.updateSalesChartFilter(days);
    },
    CashClosingBranchFilter: function (newValue) {
      this.filterCCByBranch();
    },
    SalesStatsBranchFilter: async function (newValue, oldValue) {
      let days;
      let since;
      let today = moment();
      switch (this.salesSliderCV) {
        case 0:
          days = 7;
          break;
        case 1:
          since = moment().subtract(1, "months");
          days = today.diff(since, "days");
          break;
        case 2:
          since = moment().subtract(6, "months");
          days = today.diff(since, "days");
          break;
        case 3:
          since = moment().subtract(1, "years");
          days = today.diff(since, "days");
          break;
        case 4:
          days = false;
          break;
      }
      this.branchBoxFilter = false;
      if (!oldValue && newValue) {
        let filter = { sucursal: { $oid: this.SalesStatsBranchFilter } };
        if (days) {
          filter.fechaCierre = {
            $gte: moment().subtract(days, "days").toDate(),
          };
        }
        const sdk = new ChartsEmbedSDK({
          baseUrl: JSON.parse(sessionStorage.getItem("URLs")).Charts,
          getUserToken: () =>
            Promise.resolve(sessionStorage.getItem("jCxbraoQeD")),
        });
        this.salesCharts.pie = await sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesPie2,
          showAttribution: false,
          filter: { ...filter },
        });
        this.salesCharts.line = await sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesLine2,
          showAttribution: false,
          filter: { ...filter },
        });
        const { ...barFilter } = filter;
        this.salesCharts.bar = await sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesBar2,
          showAttribution: false,
          filter: { ...filter },
        });
        this.$nextTick(() => {
          let chart1 = document.getElementById("chart");
          let chart2 = document.getElementById("salesChart2");
          let chart3 = document.getElementById("salesChart3");
          this.salesCharts.bar.render(chart1);
          this.salesCharts.pie.render(chart2);
          this.salesCharts.line.render(chart3);

          // console.log("this.$refs.myDiv*************************");
          // console.log(this.$refs.myDiv);
        });
        await this.updateSalesStatistics(days);
        await this.updateSalesChartFilter(days);
      } else if (!newValue && oldValue) {
        let filter = {};
        // this.branchBoxFilter = false;
        if (days) {
          filter.fechaCierre = {
            $gte: moment().subtract(days, "days").toDate(),
          };
        }
        const sdk = new ChartsEmbedSDK({
          baseUrl: JSON.parse(sessionStorage.getItem("URLs")).Charts,
          getUserToken: () =>
            Promise.resolve(sessionStorage.getItem("jCxbraoQeD")),
        });
        this.salesCharts.bar = sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesBar,
          showAttribution: false,
          filter: { ...filter },
        });
        this.salesCharts.pie = sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesPie,
          showAttribution: false,
          filter: { ...filter },
        });
        this.salesCharts.line = sdk.createChart({
          chartId: JSON.parse(sessionStorage.getItem("Charts"))
            .OverviewSalesLine,
          showAttribution: false,
          filter: { ...filter },
        });
        this.$nextTick(() => {
          let chart1 = document.getElementById("chart");
          let chart2 = document.getElementById("salesChart2");
          let chart3 = document.getElementById("salesChart3");
          this.salesCharts.bar.render(chart1);
          this.salesCharts.pie.render(chart2);
          this.salesCharts.line.render(chart3);
          this.updateSalesStatistics(days);
          this.updateSalesChartFilter(days);
          // console.log("this.$refs.myDiv*************************");
          // console.log(this.$refs.myDiv);
        });
      } else {
        await this.updateSalesStatistics(days);
        await this.updateSalesChartFilter(days);
      }
    },
    branchBoxFilter: async function (newValue) {
      if (this.SalesStatsBranchFilter) {
        let days;
        switch (this.salesSliderCV) {
          case 0:
            days = 7;
            break;
          case 1:
            since = moment().subtract(1, "months");
            days = today.diff(since, "days");
            break;
          case 2:
            since = moment().subtract(6, "months");
            days = today.diff(since, "days");
            break;
          case 3:
            since = moment().subtract(1, "years");
            days = today.diff(since, "days");
            break;
          case 4:
            days = false;
            break;
        }
        this.updateSalesStatistics(days);
        this.updateSalesChartFilter(days);
      }
    },
  },
  methods: {
    async test() {
      const test = await this.createCashClosingsExportData();
      console.log(test);
    },
    async handleExportCashClosings() {
      this.$swal.fire({
        title: "Exportando Resumen de Cierres de Caja",
        text: "Esto puede tardar un poco...",
        icon: "info",
        iconHtml: `<i class="fa fa-spinner fa-pulse fa-fw"></i><span class="sr-only">Loading...</span>`,
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      let data;
      let template;
      try {
        template = await this.fetchExcelTemplate("ResumenCierresDeCaja");
      } catch (error) {
        console.error(error);
        await this.$swal
          .fire({
            title: "Error!",
            text: "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return;
          });
      }
      if (!template || template.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              template.error ||
              "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return;
          });
      }
      try {
        data = await this.createCashClosingsExportData();
      } catch (error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              "Ha ocurrido un error mientras se recuperaba la información: " +
              error.message,
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return;
          });
      }
      if (!data || data.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              data.error ||
              "Ha ocurrido un error mientras se recuparaba la información",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return;
          });
      }

      try {
        await XLSXpopulate.fromDataAsync(template).then(async (wb) => {
          wb.sheet(0)
            .cell("D3")
            .value(this.$moment().format("DD/MM/YYYY - HH:mm:ss"));
          data.forEach((register, i) => {
            wb.sheet(0)
              .cell(`C${i + 7}`)
              .value(parseInt(i + 1));
            if (register.caja) {
              wb.sheet(0)
                .cell(`D${i + 7}`)
                .value(register.caja);
            }
            if (register.responsable) {
              wb.sheet(0)
                .cell(`E${i + 7}`)
                .value(register.responsable);
            }
            if (this.$moment(register.fechaApertura).toDate()) {
              wb.sheet(0)
                .cell(`F${i + 7}`)
                .value(this.$moment(register.fechaApertura).toDate());
            }
            if (register.horaApertura) {
              wb.sheet(0)
                .cell(`G${i + 7}`)
                .value(register.horaApertura.split(" ")[0]);
            }
            if (this.$moment(register.fechaCierre).toDate()) {
              wb.sheet(0)
                .cell(`H${i + 7}`)
                .value(this.$moment(register.fechaCierre).toDate());
            }
            if (register.horaCierre) {
              wb.sheet(0)
                .cell(`I${i + 7}`)
                .value(register.horaCierre.split(" ")[0]);
            }
            if (register.nombreSucursal) {
              wb.sheet(0)
                .cell(`J${i + 7}`)
                .value(register.nombreSucursal);
            }
            if (this.$moment(register.fechaRegistro).toDate()) {
              wb.sheet(0)
                .cell(`K${i + 7}`)
                .value(this.$moment(register.fechaRegistro).toDate());
            }
            if (
              register.totalSistema &&
              typeof register.totalSistema === "object"
            ) {
              if (!isNaN(`${register.totalSistema.ventasEfectivo}`)) {
                wb.sheet(0)
                  .cell(`L${i + 7}`)
                  .value(register.totalSistema.ventasEfectivo);
              }
              if (!isNaN(`${register.totalSistema.ventasTDebito}`)) {
                wb.sheet(0)
                  .cell(`M${i + 7}`)
                  .value(register.totalSistema.ventasTDebito);
              }
              if (!isNaN(`${register.totalSistema.ventasTCredito}`)) {
                wb.sheet(0)
                  .cell(`N${i + 7}`)
                  .value(register.totalSistema.ventasTCredito);
              }
              if (!isNaN(`${register.totalSistema.ventasCheque}`)) {
                wb.sheet(0)
                  .cell(`O${i + 7}`)
                  .value(register.totalSistema.ventasCheque);
              }
              if (!isNaN(`${register.totalSistema.ventasTransferencia}`)) {
                wb.sheet(0)
                  .cell(`P${i + 7}`)
                  .value(register.totalSistema.ventasTransferencia);
              }
              if (!isNaN(`${register.totalSistema.ventasCreditoLocal}`)) {
                wb.sheet(0)
                  .cell(`Q${i + 7}`)
                  .value(register.totalSistema.ventasCreditoLocal);
              }
              if (!isNaN(`${register.totalSistema.ventasTotales}`)) {
                wb.sheet(0)
                  .cell(`R${i + 7}`)
                  .value(register.totalSistema.ventasTotales);
              }
              if (!isNaN(`${register.totalSistema.cajaInicial}`)) {
                wb.sheet(0)
                  .cell(`S${i + 7}`)
                  .value(register.totalSistema.cajaInicial);
              }
              if (!isNaN(`${register.totalSistema.totalEnCaja}`)) {
                wb.sheet(0)
                  .cell(`T${i + 7}`)
                  .value(register.totalSistema.totalEnCaja);
              }
            }
            if (
              register.totalRatificado &&
              typeof register.totalRatificado === "object"
            ) {
              if (!isNaN(`${register.totalRatificado.ventasEfectivo}`)) {
                wb.sheet(0)
                  .cell(`U${i + 7}`)
                  .value(register.totalRatificado.ventasEfectivo);
              }
              if (!isNaN(`${register.totalRatificado.ventasTDebito}`)) {
                wb.sheet(0)
                  .cell(`V${i + 7}`)
                  .value(register.totalRatificado.ventasTDebito);
              }
              if (!isNaN(`${register.totalRatificado.ventasTCredito}`)) {
                wb.sheet(0)
                  .cell(`W${i + 7}`)
                  .value(register.totalRatificado.ventasTCredito);
              }
              if (!isNaN(`${register.totalRatificado.ventasCheque}`)) {
                wb.sheet(0)
                  .cell(`X${i + 7}`)
                  .value(register.totalRatificado.ventasCheque);
              }
              if (!isNaN(`${register.totalRatificado.ventasTransferencia}`)) {
                wb.sheet(0)
                  .cell(`Y${i + 7}`)
                  .value(register.totalRatificado.ventasTransferencia);
              }
              if (!isNaN(`${register.totalRatificado.ventasCreditoLocal}`)) {
                wb.sheet(0)
                  .cell(`Z${i + 7}`)
                  .value(register.totalRatificado.ventasCreditoLocal);
              }
              if (!isNaN(`${register.totalRatificado.ventasTotales}`)) {
                wb.sheet(0)
                  .cell(`AA${i + 7}`)
                  .value(register.totalRatificado.ventasTotales);
              }
              if (!isNaN(`${register.totalRatificado.cajaInicial}`)) {
                wb.sheet(0)
                  .cell(`AB${i + 7}`)
                  .value(register.totalRatificado.cajaInicial);
              }
              if (!isNaN(`${register.totalRatificado.totalEnCaja}`)) {
                wb.sheet(0)
                  .cell(`AC${i + 7}`)
                  .value(register.totalRatificado.totalEnCaja);
              }
              if (
                !isNaN(`${register.totalRatificado.totalDiferencia}`) &&
                register.totalRatificado.indicadorDiferencia
              ) {
                let operatorSplit =
                  register.totalRatificado.indicadorDiferencia.split(" ");
                let value = register.totalRatificado.totalDiferencia;
                if (value > 0) {
                  // console.log(value);
                  value =
                    operatorSplit[1] === "(-):" ? -Math.abs(value) : value;
                }
                if (operatorSplit[1]) {
                  wb.sheet(0)
                    .cell(`AD${i + 7}`)
                    .value(
                      operatorSplit[1] === "(-):" ? "NEGATIVA" : "POSITIVA"
                    );
                }
                wb.sheet(0)
                  .cell(`AE${i + 7}`)
                  .value(value);
              }
            }
          });
          await wb
            .outputAsync()
            .then((blob) => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `Resumen de Cierres [Exp: ${this.$moment().format(
                    "DD-MM-yyyy - HH-mm-ss"
                  )}].xlsx`
                );
              } else {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = `Resumen de Cierres [Exp: ${this.$moment().format(
                  "DD-MM-yyyy - HH-mm-ss"
                )}].xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }
              this.$swal.close();
            })
            .catch((error) => {
              console.error(error);
              this.$swal
                .fire({
                  title: "Error!",
                  text:
                    error.message ||
                    "Ha ocurrido un error durante la renderización del resumen",
                  confirmButtonColor: "#6bd098",
                  icon: "error",
                })
                .then(() => {
                  return;
                });
            });
        });
      } catch (error) {
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message ||
              "Ha ocurrido un error durante la renderización del respaldo",
            confirmButtonColor: "#6bd098",
            icon: "error",
          })
          .then(() => {
            return;
          });
      } finally {
        this.exportData = [];
      }
    },
    async fetchExcelTemplate(templateName) {
      const template = templateName;
      try {
        const response = await this.$XLSXTemplateDownload.post(
          "",
          {
            template: template,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
            },
            responseType: "arraybuffer",
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error al cargar el archivo xlsx:", error);
        return {
          error:
            error.message ||
            `Ha ocurrido un error inesperado al recuperar la plantilla excel`,
        };
      }
    },
    async createCashClosingsExportData() {
      var Parameters = {
        branch: this.CashClosingBranchFilter,
      };
      if (this.boxFilter) {
        Parameters.box = this.boxFilter;
      }
      if (this.dateBoxFilter) {
        const datesArr = this.dateBoxFilter;
        Parameters.dateFilters = {
          since: datesArr[0],
          till: datesArr[1],
        };
      }
      let keepFetching = true;
      let page = 0;
      let currentResponse;
      let error;
      do {
        try {
          currentResponse = await this.$MasterControlAPP.post(
            "",
            {
              Parameters: {
                page: page,
                ...Parameters,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/cashclosings/reportformat",
              },
            }
          );
          // console.log("currentResponse");
          // console.log(currentResponse);
          if (currentResponse.data.error) {
            keepFetching = false;
            this.$swal.fire({
              title: "Error!",
              text: currentResponse.data.error,
              confirmButtonColor: "#6bd098",
            });
          } else {
            const fetchedData = currentResponse.data.result;
            if (fetchedData) {
              this.exportData.push(...fetchedData);
            }
            keepFetching = fetchedData.length === 100;
            page++;
          }
        } catch (error) {
          keepFetching = false;
          error = error;
          console.error(error);
        }
      } while (keepFetching);
      if (this.exportData && !error) {
        return this.exportData;
      } else if (error) {
        return {
          error:
            error.message ||
            "Ha ocurrido un error inesperado durante la consulta de datos para generar el reporte",
        };
      } else {
        return { error: "La consulta no retornó datos para generar reporte" };
      }
    },
    checkOverflow() {
      const isOverflowed =
        this.$refs.myDiv.clientWidth < this.$refs.myDiv.scrollWidth;
      // Utiliza isOverflowed según tus necesidades
      // console.log(isOverflowed);
      this.isOverflowed = isOverflowed;
    },
    fscrollToRight() {
      var container = document.getElementById("tuDiv"); // Reemplaza "tuDiv" con el ID de tu div
      container.scrollLeft = container.scrollWidth;
      this.horizontalScrollToggle = !this.horizontalScrollToggle;
      return;
    },
    fscrollToLeft() {
      var container = document.getElementById("tuDiv"); // Reemplaza "tuDiv" con el ID de tu div
      this.horizontalScrollToggle = !this.horizontalScrollToggle;
      container.scrollLeft = 0;
      return;
    },
    async getMembershipsStats() {
      let response;
      this.membershipsIsLoading = true;
      try {
        response = await this.$MasterControlAPP
          .post(
            "",
            {
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {},
              URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
            },
            {
              headers: {
                yebajJVkaZ: this.$ToDesa,
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: this.getOP("MembershipsStatistics"),
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .MembershipsStatistics,
              },
            }
          )
          .then((response) => {
            let dataOut = response.data;
            // console.log("dataOut************************************");
            // console.log(dataOut);
            dataOut.forEach((item) => {
              // console.log("item: ", item._id)
              // console.log(item)
              console.log('Sucursal bill')
              console.log(item)
              if (item._id != "billing") {
                if (item._id === "ACTIVOS") {
                  this.statsCards[item._id].sub = `Tramo: ${item.billing}`;
                  this.$store.commit("setMembershipsCounter", item.count);
                } else if (item._id != "ACTIVOS" && item._id != "PENDIENTE") {
                  this.activeCatlog.push({ $oid: item.cat });
                }
                this.statsCards[item._id].title = `${item._id}`;
                this.statsCards[item._id].value = `${item.count}`;
                this.statsCards[item._id].cat = `${item.cat}`;
              } else {
                this.branchesBilling = item.result;
              }
            });
            this.membershipsIsLoading = false;
          })
          .catch((err) => {
            console.error(err.message);
            console.error("+++++++++++++++++++++++++++");
          });
      } catch (err) {
        console.error(err.message);
        console.error("+++++++++++++++++++++++++++");
      } finally {
        return response;
      }
      return;
    },
    async getLastCashClosing(page) {
      this.CashClosingsIsLoading = true;
      let response;
      this.cashClosings = [];
      var Parameters = {
        page: page || 1 - this.pagination.currentPage,
        branch: this.CashClosingBranchFilter,
      };
      if (this.boxFilter) {
        Parameters.box = this.boxFilter;
      }
      if (this.dateBoxFilter) {
        const datesArr = this.dateBoxFilter;
        Parameters.dateFilters = {
          since: datesArr[0],
          till: datesArr[1],
        };
      }
      try {
        response = await this.$MasterControlAPP
          .post(
            "",
            {
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: Parameters,
              URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
            },
            {
              headers: {
                yebajJVkaZ: this.$ToDesa,
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: this.getOP("LastCashClosings"),
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .LastCashClosings,
              },
            }
          )
          .then((response) => {
            this.CashClosingsIsLoading = false;
            let dataOut = response.data;
            this.pagination.total = dataOut.pages;
            // console.log("dataOut.pages");
            // console.log(dataOut.pages);
            // console.log(this.pagination.total )
            this.cashClosings = [];
            if (dataOut.result) {
              dataOut.result.forEach((item) => {
                let dateFormated = this.$moment(item.fechaRegistro).format(
                  "DD-MM-YYYY"
                );
                this.cashClosings.push({
                  id: item._id,
                  sucursal: item.nombreSucursal,
                  responsable: item.responsable,
                  caja: item.caja,
                  fecha: dateFormated,
                });
              });
            }
          })
          .catch((err) => {
            console.error(err);
            console.error("+++++++++++++++++++++++++++");
          });
      } catch (err) {
        console.error("+++++++++++++++++++++++++++");
        console.error(err);
      } finally {
        return response;
      }
      return;
    },
    async filterCCByBranch() {
      this.pagination.currentPage = 1;
      await this.getLastCashClosing();
      return;
    },
    async getAccessStatistics(days) {
      // console.log("llamanding");
      let range = days || 0;
      this.AccessStatisticsIsLoading = true;
      this.activeUsersChart.datasets[0].data = [];
      this.activeUsersChart.datasets[0].total = 0;
      this.branchesCardShow = {
        Title: "",
        Total: "",
        average: "",
      };
      let response;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                days: range,
              },
              URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
            },
            {
              headers: {
                yebajJVkaZ: this.$ToDesa,
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                // operation: this.getOP("AccessStatistics"),
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .AccessStatistics,
              },
            }
          )
          .then((response) => {
            // console.log("response***");
            // console.log(response);
            let fromatedData = {};
            this.AccessStatisticsIsLoading = false;
            response.data.chartData.forEach((record) => {
              fromatedData[`${record._id}Hrs`] = record.count;
            });
            this.activeUsersChart.labels.forEach((record) => {
              this.activeUsersChart.datasets[0].data.push(
                fromatedData[`${record}`] || 0
              );
              this.activeUsersChart.datasets[0].range = range;
            });
            this.activeUsersChart.datasets[0].total = response.data.total;
            this.activeUsersChart.datasets[0].average = response.data.average;

            this.activeUsersChart.datasets[0].peak = response.data.peak
              ? response.data.peak
              : { _id: "No Data" };
            this.branches = response.data.branchesStatistics;
            if (response.data.branchesStatistics.length > 0) {
              this.branchesCardShow = {
                Title: response.data.branchesStatistics[0]._id,
                Total: response.data.branchesStatistics[0].count,
                average: response.data.branchesStatistics[0].average,
              };
            } else {
              this.branchesCardShow = {
                Title: "No Data",
                Total: "No Data",
                average: "No Data",
              };
            }
          });
      } catch (err) {
        console.error("err error");
        console.error(err);
        console.error(response);
        return response;
      } finally {
        return response;
      }
      return;
    },
    async getSalesStatistics(days) {
      this.salesStats = {
        totalIncome: 0,
        dailyAverage: 0,
        bestBranch: "",
      };
      try {
        const response = await this.$MasterControlAPP.post(
          "",
          {
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Parameters: {
              days: days,
              branch: this.SalesStatsBranchFilter,
            },
            URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
          },
          {
            headers: {
              yebajJVkaZ: this.$ToDesa,
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              //operation: this.getOP("SalesStatistics"),
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .SalesStatistics,
            },
          }
        );
        this.salesStats = {
          totalIncome: Math.ceil(response.data.totalIncome[0].ingresosTotales),
          dailyAverage: Math.ceil(response.data.dailyAverage[0].promedioDiario),
          bestBranch: response.data.bestBranch._id,
        };
      } catch (ex) {
        console.error("Error: [getSalesStatistics] - ", ex);
      } finally {
      }
      return;
    },
    async updateSalesChartFilter(days) {
      // let chart = document.getElementById("chart");
      // let chart2 = document.getElementById("salesChart2");
      // let chart3 = document.getElementById("salesChart3");
      let filter;
      if (!days) {
        filter = {};
      } else {
        filter = {
          fechaCierre: { $gte: moment().subtract(days, "days").toDate() },
        };
      }
      if (this.SalesStatsBranchFilter) {
        filter.sucursal = { $oid: this.SalesStatsBranchFilter };
      }
      if (this.branchBoxFilter) {
        filter.caja = this.branchBoxFilter;
      }
      await this.salesCharts.line.setFilter(filter);
      await this.salesCharts.pie.setFilter(filter);
      const { caja, ...barFilter } = filter;
      await this.salesCharts.bar.setFilter(barFilter);
      await this.salesCharts.line.refresh();
      await this.salesCharts.bar.refresh();
      await this.salesCharts.pie.refresh();
      return;
    },
    updateGetAccessStatistics(days) {
      this.AccessStatisticsIsLoading = true;
      this.getAccessStatistics(days);
    },
    async updateSalesStatistics(days) {
      await this.getSalesStatistics(days);
      return;
    },
    setActiveLink(index) {
      this.AccessStatisticsActiveLink = index;
    },
    updateBranchesCard(index) {
      this.setActiveLink(index);
      this.branchesCardShow.Title = this.branches[index]._id;
      this.branchesCardShow.Total = this.branches[index].count;
      this.branchesCardShow.average = this.branches[index].average;
    },
    renderMonthlySalesChart(range) {
      let since;
      switch (range) {
        case !range:
          since = moment().subtract(1, "years").toDate();
          break;
        case 1:
          since = moment().subtract(6);
      }
    },
    // CC: Cash Closing
    async downloadCC(id, responsable, caja, fecha) {
      this.$swal.fire({
        title: "Cargando...",
        text: "Un momento por favor.",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        const response = await this.$DownLoadsMasterControl.post(
          "",
          {
            Auth: {
              Token: sessionStorage.getItem("jCxbraoQeD"),
            },
            Parameters: { id: id },
            URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
          },
          {
            responseType: "blob",
            headers: {
              yebajJVkaZ: this.$ToDesa,
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                .DownloadCashClosing,
            },
          }
        );

        this.downloadBlob(
          response.data,
          `cierre de caja [${caja}][usr - ${responsable}][${fecha}].xlsx`
        );
        this.$swal.close();
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
      }
      return;
    },
    downloadBlob(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    },
    onPageChange(newPage) {
      this.getLastCashClosing(newPage - 1);
      // this.pagination.currentPage = newPage;
      // this.getLastCashClosing(); // Llama a la función que carga los datos para la nueva página
    },
    getOP(key) {
      return this.$store.getters.getOP(key);
    },
    hideCCModal() {
      const CCModal = document.getElementById("CCShowDetails");
      if (CCModal) {
        CCModal.classList.add("d-none");
      }
    },
    async showCCModal(id) {
      this.$swal.fire({
        title: "Cargando...",
        text: "Un momento por favor",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const CCModal = document.getElementById("CCShowDetails");
      if (CCModal) {
        this.CCModalData = {
          caja: "",
          fechaApertura: "",
          fechaCierre: "",
          fechaRegistro: "",
          horaApertura: "",
          horaCierre: "",
          nombreSucursal: "",
          responsable: "",
          totalRatificado: {
            cajaInicial: 0,
            indicadorDiferencia: "",
            totalDiferencia: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0,
          },
          totalSistema: {
            cajaInicial: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0,
          },
        };
        try {
          const CCDetails = await this.$MasterControlAPP.post(
            "",
            {
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                id: id,
              },
              URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
            },
            {
              headers: {
                yebajJVkaZ: this.$ToDesa,
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                //operation: this.getOP("SalesStatistics"),
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .CashClosingDetails,
              },
            }
          );
          let newCCModalData = CCDetails.data[0];
          if (typeof newCCModalData.fechaApertura === "string") {
            newCCModalData.fechaApertura = this.$moment(
              newCCModalData.fechaApertura.split("T")[0]
            ).format("DD-MM-YYYY");
          }
          if (typeof newCCModalData.fechaCierre === "string") {
            newCCModalData.fechaCierre = this.$moment(
              newCCModalData.fechaCierre.split("T")[0]
            ).format("DD-MM-YYYY");
          }
          this.CCModalData = { ...newCCModalData };
          // console.log(newCCModalData);
        } catch (ex) {
          console.error("Error: [showCCModal] - ", ex);
          this.$swal.fire({
            title: "Error :(!",
            text:
              ex.message ||
              "Ha ocurrido un error inseperado, ponte en contacto con soporte",
            showConfirmButton: true,
            icon: "error",
            confirmButtonColor: "#6bd098",
          });
        } finally {
          this.$swal.close();
          CCModal.classList.remove("d-none");
        }
        return;
      }
    },
    async showCCModalMobile(id) {
      const CCModal = document.getElementById("CCShowDetails");
      if (CCModal) {
        this.CCModalData = {
          caja: "",
          fechaApertura: "",
          fechaCierre: "",
          fechaRegistro: "",
          horaApertura: "",
          horaCierre: "",
          nombreSucursal: "",
          responsable: "",
          totalRatificado: {
            cajaInicial: 0,
            indicadorDiferencia: "",
            totalDiferencia: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0,
          },
          totalSistema: {
            cajaInicial: 0,
            totalEnCaja: 0,
            ventasCheque: 0,
            ventasCreditoLocal: 0,
            ventasEfectivo: 0,
            ventasTCredito: 0,
            ventasTDebito: 0,
            ventasTotales: 0,
            ventasTransferencia: 0,
          },
        };
        try {
          const CCDetails = await this.$MasterControlAPP.post(
            "",
            {
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                id: id,
              },
              URL: "https://us-east-1.aws.data.mongodb-api.com/app/mastercontrol-axkuo/endpoint/v1/statistics/access/hours",
            },
            {
              headers: {
                yebajJVkaZ: this.$ToDesa,
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                //operation: this.getOP("SalesStatistics"),
                operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                  .CashClosingDetails,
              },
            }
          );
          let newCCModalData = CCDetails.data[0];
          if (typeof newCCModalData.fechaApertura === "string") {
            newCCModalData.fechaApertura = this.$moment(
              newCCModalData.fechaApertura.split("T")[0]
            ).format("DD-MM-YYYY");
          }
          if (typeof newCCModalData.fechaCierre === "string") {
            newCCModalData.fechaCierre = this.$moment(
              newCCModalData.fechaCierre.split("T")[0]
            ).format("DD-MM-YYYY");
          }
          this.CCModalData = { ...newCCModalData };
        } catch (ex) {
          console.error("Error: [showCCModalMobile] - ", ex);
        } finally {
          this.modals.notice = true;
        }
      }
      return;
    },
    openMemberships(cat) {
      this.$store.commit("setMembershipFilter", cat);
    },
    goToCustomers(catId, catDesc) {
      if (!catId) {
        this.$store.commit("setMembershipFilter", this.activeCatlog);
        this.$store.commit("setMembershipsDDtag", "ACTIVOS");
      } else {
        this.$store.commit("setMembershipFilter", [{ $oid: catId }]);
        this.$store.commit("setMembershipsDDtag", catDesc);
      }
      // this.$swal.fire({
      //   title: "Cargando...",
      //   allowOutsideClick: false,
      //   showConfirmButton: false,
      //   onBeforeOpen: () => {
      //     this.$swal.showLoading();
      //   },
      // });
      this.$router.push("/customers&memberships/memberships").then(() => {
        // this.$swal.close()
      });
    },
    showBranches() {
      // console.log("mostrando sucursales");
      // console.log(this.userBranches);
    },
  },
  beforeMount() {
    this.userBranches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
  },
  mounted() {
    if (this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize();
    }
    // Inicia la carga de datos y gráficos.
    Promise.all([
      this.getAccessStatistics(1),
      this.getMembershipsStats(),
      this.getLastCashClosing(),
      this.getSalesStatistics(7),
    ]).then(() => {
      // Después de que todos los datos se hayan cargado, configura los gráficos.
      const sdk = new ChartsEmbedSDK({
        baseUrl: JSON.parse(sessionStorage.getItem("URLs")).Charts,
        getUserToken: () =>
          Promise.resolve(sessionStorage.getItem("jCxbraoQeD")),
      });

      this.salesCharts.bar = sdk.createChart({
        chartId: JSON.parse(sessionStorage.getItem("Charts")).OverviewSalesBar,
        showAttribution: false,
        filter: {
          fechaCierre: { $gte: moment().subtract(7, "days").toDate() },
        },
      });
      this.salesCharts.pie = sdk.createChart({
        chartId: JSON.parse(sessionStorage.getItem("Charts")).OverviewSalesPie,
        showAttribution: false,
        filter: {
          fechaCierre: { $gte: moment().subtract(7, "days").toDate() },
        },
      });
      this.salesCharts.line = sdk.createChart({
        chartId: JSON.parse(sessionStorage.getItem("Charts")).OverviewSalesLine,
        showAttribution: false,
        filter: {
          fechaCierre: { $gte: moment().subtract(7, "days").toDate() },
        },
      });

      // Asegúrate de que el DOM se haya actualizado por completo antes de renderizar los gráficos.
      this.$nextTick(() => {
        this.acountType = sessionStorage.getItem("account-type");
        let chart1 = document.getElementById("chart");
        let chart2 = document.getElementById("salesChart2");
        let chart3 = document.getElementById("salesChart3");
        this.salesCharts.bar.render(chart1);
        this.salesCharts.pie.render(chart2);
        this.salesCharts.line.render(chart3);

        const observer = new ResizeObserver(() => {
          this.checkOverflow();
        });
        // console.log("this.$refs.myDiv*************************");
        // console.log(this.$refs.myDiv);
        observer.observe(this.$refs.myDiv);
        this.$swal.close();
      });
    });
  },
  beforeDestroy() {
    this.$swal.fire({
      title: "Cargando...",
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        this.$swal.showLoading();
      },
    });
  },
};
</script>
<style>
#CCShowDetails {
  height: 100vh;
  widows: 100vw;
  background: #2c2c2c7e;
}
#CCShowDetails .cc-close-modal {
  font-size: 30px;
  font-weight: bolder;
  cursor: pointer;
}
.row .chart {
  min-height: 400px;
}
.sales-charts #chart {
  min-height: 500px;
}
/* .row .chart > body:first-child {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 10px 10px 5px -3px rgba(0, 0, 0, 0.33);
} */
</style>
